import React, {
  ComponentProps,
  FunctionComponent,
  ReactNode,
  useState,
} from 'react'
import { logger } from '~/shared/lib/logger'
import { Button } from '../Buttons'
import { Dialog } from './styled'

type ModalProps = {
  children: ReactNode
  isShow: boolean
  ok?: string
  cancel?: string
  canBackdropClose?: boolean
  extraBottom?: ReactNode
  okButtonProps?: Partial<ComponentProps<typeof Button>>
  cancelButtonProps?: Partial<ComponentProps<typeof Button>>
  sx?: React.CSSProperties
  onOk?: () => Promise<void> | void
  onCancel?: () => void
}

export const Modal: FunctionComponent<ModalProps> = ({
  isShow,
  children,
  ok = 'Хорошо',
  onOk,
  onCancel,
  cancel = 'Отмена',
  canBackdropClose = true,
  extraBottom,
  okButtonProps,
  cancelButtonProps,
  sx,
}) => {
  const [loading, setLoading] = useState(false)

  const handleOnClose = () => {
    if (loading) return
    onCancel?.()
  }

  const handleBackdropClose = () => {
    if (loading) return
    onOk?.()
  }

  const handleOnOk = async () => {
    try {
      setLoading(true)
      await onOk?.()
    } catch (e) {
      logger.error('Modal send error:', e)
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog
      isOpen={isShow}
      onDidDismiss={canBackdropClose ? handleBackdropClose : undefined}
      backdropDismiss={canBackdropClose}
      data-testid={'modal'}
      style={sx}
      keepContentsMounted={false}
    >
      <div>
        {children}

        {(onOk || onCancel) && <br />}

        {onOk && (
          <Button
            expand='block'
            disabled={loading}
            onClick={handleOnOk}
            data-testid={`submit-modal-button-${ok}`}
            style={{ marginBottom: onCancel ? '16px' : 0 }}
            {...okButtonProps}
          >
            {loading ? 'Загрузка...' : ok}
          </Button>
        )}

        {onCancel && (
          <Button
            onClick={handleOnClose}
            variant='lightSteelBlueBorder'
            disabled={loading}
            {...cancelButtonProps}
            fullWidth
          >
            {cancel}
          </Button>
        )}

        {extraBottom}
      </div>
    </Dialog>
  )
}
